module.exports = __webpack_public_path__ + "static/media/theme.72ae5def.ogg";